import { render, staticRenderFns } from "./ReferralsList.vue?vue&type=template&id=49c48942"
import script from "./ReferralsList.vue?vue&type=script&lang=js"
export * from "./ReferralsList.vue?vue&type=script&lang=js"
import style0 from "./ReferralsList.vue?vue&type=style&index=0&id=49c48942&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports